var map = {
	"./de/btn-view.png": "cuHV",
	"./en/btn-view.png": "dhIO",
	"./es/btn-view.png": "p4eS",
	"./fr/btn-view.png": "v7Q3",
	"./ja/btn-view.png": "uxMP",
	"./ko/btn-view.png": "Xhc4",
	"./pt/btn-view.png": "d2UX",
	"./ru/btn-view.png": "Dtd8",
	"./tc/btn-view.png": "wSuD",
	"./th/btn-view.png": "sS9Q"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "P9Bs";